import axios from 'axios';
import { useQueryClient, useQuery } from '@tanstack/react-query';
import { fetchDefault, fetchFormAuth, setError } from 'src/fetch/common';
import { homeTaxInitData, homeTaxData } from 'src/static/sample/stepC';
import { dataSet, houseLoanDataSet } from './dataSet';
import { familyInfoDataFn } from 'src/fetch/stepA';
import _ from 'lodash';
import { error } from 'console';
const stateTimeStr = process.env.REACT_APP_REACTQUERY_STALETIME || '0';
const STALETIME = Number(stateTimeStr);

// SELECT(LIST) 주택자금:전세
export const houseRentFInfoDataFn = async (
  errorModalState: any,
  param: any,
  initDataStore: any,
  queryClient: any,
  familyInfoDataState?: any,
  familyData?: any
) => {
  const paramSet = param;
  const fetchUrl = '/api/housingfunds/rentf/lst';
  const fetchKey = 'HOUSING_RENT_F_INFO';
  if (!familyData) {
    familyData = await familyInfoDataFn(errorModalState, param, familyInfoDataState, queryClient);
  }
  const familyDataSet = _.cloneDeep(familyData);
  try {
    const data = await queryClient.fetchQuery({
      queryKey: [fetchKey],
      queryFn: () => fetchDefault(paramSet, fetchUrl),
    });
    const infoData: any = data;
    const { resError, resData } = houseLoanDataSet(infoData, familyDataSet, null);
    console.log('[HOUSING_RENT_F_INFO]:', paramSet, data, resData);
    if (resError.type === 'error') {
      errorModalState({ data: resError, active: '_active' });
    } else {
      initDataStore({ data: resData });
      return resData;
    }
  } catch (e) {
    console.log('error:', e);
  }
};

// INSERT
export const fetchInsertHouseRentF = async (
  param: any,
  queryClient: any,
  errorModalState: any,
  loadingState: any,
  callback: any
) => {
  const paramSet = param;
  const fetchUrl = '/api/housingfunds/rentf/ist';
  const fetchKey = 'HOUSING_RENT_F_INSERT';

  try {
    loadingState({ active: '_active' });
    const queryData = await queryClient.fetchQuery({
      queryKey: [fetchKey],
      queryFn: () => fetchDefault(paramSet, fetchUrl),
    });
    loadingState({ active: '' });

    const errorSet = setError(queryData, null);
    if (errorSet.type === 'error') {
      console.log('ERROR');
      errorModalState({ data: errorSet, active: '_active' });
    } else {
      callback();
    }
  } catch (e) {
    console.log('error:', e);
  }
};
// UPDATE
export const fetchUpdateHouseRentF = async (
  param: any,
  queryClient: any,
  errorModalState: any,
  loadingState: any,
  callback: any
) => {
  const paramSet = param;
  const fetchUrl = '/api/housingfunds/rentf/upd';
  const fetchKey = 'HOUSING_RENT_F_UPDATE';

  try {
    loadingState({ active: '_active' });
    const queryData = await queryClient.fetchQuery({
      queryKey: [fetchKey],
      queryFn: () => fetchDefault(paramSet, fetchUrl),
    });
    loadingState({ active: '' });

    const errorSet = setError(queryData, null);
    if (errorSet.type === 'error') {
      console.log('ERROR');
      errorModalState({ data: errorSet, active: '_active' });
    } else {
      callback();
    }
  } catch (e) {
    console.log('error:', e);
  }
};
// DELETE
export const fetchDeleteHouseRentF = async (
  param: any,
  queryClient: any,
  errorModalState: any,
  loadingState: any,
  callback: any
) => {
  const paramSet = param;
  const fetchUrl = '/api/housingfunds/rentf/del';
  const fetchKey = 'HOUSING_RENT_F_DELETE';

  try {
    loadingState({ active: '_active' });
    const queryData = await queryClient.fetchQuery({
      queryKey: [fetchKey, paramSet],
      queryFn: () => fetchDefault(paramSet, fetchUrl),
    });
    loadingState({ active: '' });
    const errorSet = setError(queryData, null);
    if (errorSet.type === 'error') {
      console.log('ERROR');
      errorModalState({ data: errorSet, active: '_active' });
    } else {
      callback();
    }
  } catch (e) {
    console.log('error:', e);
  }
};
